export const PROTOCOL_NAMESPACE = 'ETS.AuthService.Protocol';
